import { render } from "@/components/pages/startSSM4/StartSSM4Modal.html?vue&type=template&id=8ccebc26&external"
import script from "@/components/pages/startSSM4/StartSSM4Modal.js?vue&type=script&lang=js&external"
export * from "@/components/pages/startSSM4/StartSSM4Modal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__